import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { logError } from '../lib/errorHandler';

const defaultLayout = {
  growth_instructions: 'tools',
  gold_file: 'tools',
  growth_opportunities: 'tools',
  goals: 'tools',
  community: 'tools',
  vision: 'tools',
  lessons: 'tools'
};

export default function useSectionLayout() {
  const [locations, setLocations] = useState<Record<string, string>>(defaultLayout);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchLayout() {
      setError(null);

      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        const userId = session?.user?.id;

        if (!userId || sessionError) {
          setError('No active session');
          return;
        }

        const { data, error: fetchError } = await supabase
          .from('customizations')
          .select('section_locations')
          .eq('user_id', userId)
          .maybeSingle();

        if (fetchError) {
          throw fetchError;
        }

        if (data?.section_locations) {
          setLocations({ ...defaultLayout, ...data.section_locations });
        }

      } catch (error) {
        logError(error, { context: 'useSectionLayout' });
        setError('Failed to load layout settings');
      }
    }

    fetchLayout();
  }, []);

  return { locations, isLoading, error };
}